export function Mobile({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.82031 2.25H12.1797C13.1586 2.25 13.6041 2.43478 13.833 2.66602C14.0641 2.89953 14.25 3.35693 14.25 4.35742V13.6426C14.25 14.6426 14.0643 15.0995 13.833 15.333C13.6034 15.5646 13.156 15.75 12.1729 15.75H5.82031C4.84135 15.75 4.39588 15.5652 4.16699 15.334C3.9359 15.1005 3.75001 14.6431 3.75 13.6426V4.35742C3.75001 3.35693 3.9359 2.89953 4.16699 2.66602C4.39588 2.43478 4.84135 2.25 5.82031 2.25ZM9 11.0996C7.86592 11.0996 6.93771 12.0281 6.9375 13.1621C6.9375 14.2963 7.86579 15.2246 9 15.2246C10.1342 15.2246 11.0625 14.2963 11.0625 13.1621C11.0623 12.0281 10.1341 11.0996 9 11.0996ZM7.5 2.8125C6.77829 2.8125 6.1875 3.40329 6.1875 4.125C6.1875 4.84671 6.77829 5.4375 7.5 5.4375H10.5C11.2217 5.4375 11.8125 4.84671 11.8125 4.125C11.8125 3.40329 11.2217 2.8125 10.5 2.8125H7.5Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
